export const common = {
  "site.name": "91免费视频",
  "site.slogan": "海量免费视频在线观看平台",
  "site.description": "91免费视频为您提供海量高清视频资源，无需注册即可免费在线观看。涵盖多种类型视频内容，支持手机、平板、电脑多端流畅播放。",
  "nav.home": "首页",
  "nav.category": "分类",
  "nav.about": "关于我们",
  "nav.search": "搜索视频...",
  "footer.copyright": "© 2024 91免费视频 版权所有",
  "footer.about": "关于我们",
  "footer.terms": "服务条款",
  "footer.privacy": "隐私政策",
  "breadcrumb.home": "首页",
  "cta.watch": "立即观看",
  "cta.more": "查看更多",
  "cta.submit": "提交",
  "video.views": "次观看",
  "video.duration": "时长",
  "video.date": "发布于",
  "category.all": "全部",
};